<template>
  <a-locale-provider :locale="chinese">
    <!-- 添加这个v-cloak 解决v-if或者v-show可能会出现div闪现-->
    <div id="febs" style="height: 100%;" @mouseover="operatingWebsite()" v-cloak>
      <!--      <router-view />-->
      <router-view v-if="isRouterAlive" />
    </div>
  </a-locale-provider>
</template>
<script>
import enquireScreen from "./utils/device";
import chinese from "ant-design-vue/lib/locale-provider/zh_CN";
import "moment/locale/zh-cn";
import store from "./store/index";
import request from "./utils/request";
let Base64 = require("js-base64").Base64;
import warterMark from "@/utils/warterMark";
import db from '@/utils/localstorage'
export default {
  name: "Febs",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    };
  },

  data() {
    return {
      chinese,
      currentTime: new Date().getTime(),
      isRouterAlive: true,

      userId: "", //webSocket使用

      isConnect: false, //webSocket连接标识 避免重复连接
      rec: "" //断线重连后，延迟5秒重新创建WebSocket连接  rec用来存储延迟请求的代码
    };
  },
  created() {
    let _this = this;
    enquireScreen(isMobile => {
      _this.$store.commit("setting/setDevice", isMobile);
    });
    // 页面创建生命周期函数
    this.initWebSocket();
  },
  computed: {
    getUserName() {
      return this.$store.getters.user.realName;
    }
  },

  //1.这个监听水印内容，可以保证一登录进来就有水印
  watch: {
    getUserName: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue != undefined && newValue != null && newValue != "") {
            warterMark.set(newValue);
          }
        }
      }
    }
  },
  //2.这个挂载水印，可以保证当页面刷新后出现水印。和上面一起使用
  //放在根目录 全局加水印
  mounted() {
    let userName = this.$store.getters.user.realName;
    if (userName) {
      if (userName != undefined && userName != null && userName != "") {
        warterMark.set(userName);
      }
    }
  },

  destroyed() {
    // 离开页面生命周期函数
    this.websocketclose();
  },

  methods: {
    //8小时没有任何操作（鼠标的点击、滑动、路由的切换、是否请求接口等），再操作的时候，会自动退出登录跳转到登录页面
    operatingWebsite() {
      let currentTime = this.currentTime;
      let lastTime = new Date().getTime();
      let timeOut = 8 * 60 * 60 * 1000; //设置时间 8小时
      if (lastTime - currentTime > timeOut) {
        // 未操作页面，跳转登录页面
        this.currentTime = new Date().getTime();
        const fullPath = this.$route.fullPath;
        const query = Base64.encode(fullPath);
        db.clear();
        this.$router.push({
          path: "/login",
          query: {
            type: query
          }
        });
      } else {
        this.currentTime = new Date().getTime();
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    /*webSocket start*/
    collapse() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        this.iconClass = "cebianlanzhankai";
      } else {
        this.iconClass = "cebianlanshouhui";
      }
    },
    initWebSocket() {
      //当前系统登录用户的Id
      //let userId = store._modules.root._children.account.state.user.userId;
      let userId=this.$store.getters.user.userId;
      if (userId != null) {
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        // this.websock = new WebSocket("ws://localhost:9091/onlinecarback/websocket/"+userId);
        //本地环境
        // let wsServer =`${location.protocol === "https" ? "wss" : "ws"}://localhost:9091/onlinecarback/websocket/` + userId;

        //测试环境 192.168.0.221:9091
         //let wsServer =`${location.protocol === "https" ? "wss" : "ws"}://192.168.0.221:9091/onlinecarback/websocket/` + userId;

        //线上环境 39.97.243.194:9091
        //webSocket 前面加一个前缀onlinecarback_ 区分后面其他项目的webSocket
         let wsServer = "wss://onlinemgr.0791jx.cn/onlinecarback_websocket/" + userId;

        //console.log("wsServer:", wsServer);
        this.websock = new WebSocket(wsServer);
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onclose = this.websocketclose;
      }
    },
    websocketonopen() {
      console.log("WebSocket连接成功");
      //连接建立后修改标识
      this.isConnect = true;
    },
    websocketonerror(e) {
      console.log("WebSocket连接发生错误");
      //连接断开后修改标识
      this.isConnect = false;
      //连接错误 需要重连
      this.reConnect();
    },

    //接收后端推送过来的消息
    websocketonmessage(e) {
      //当前系统登录用户的权限
      //let permissions = store._modules.root._children.account.state.permissions;
      let permissions = this.$store.getters.permissions;
      //console.log(e)
      //console.log("接收到后端传递过来的消息", e.data);
      if (e != null) {
        let str = JSON.parse(e.data);
        if (str.type === "driverPosition") {
          //通过这个JSON.stringify转一下，否则，取出来就变成object了
          // this.resetSetItem("driverPositionData", JSON.stringify(str.data));
          this.$store.dispatch("driverPositionDate/saveDriverPositionDatas",str.data);
        }
        if (str.type === "派单提醒") {
          if (permissions instanceof Array) {
            for (let i = 0; i < permissions.length; i++) {
              let p = permissions[i];

              //只有派单权限的用户才去打开调用消息弹窗提醒
              if (p === "order:manualSendOrder") {
                let message = str.message;
                //this.notifyMessageValue=str.message;
                if (message != null || message !== "") {
                  this.openInfoNotifySenderOrder(message);
                }
              }
            }
          }
        }
      }
    },
    websocketclose(e) {
      console.log("webSocket连接关闭：connection closed (" + e.code + ")");
      //this.notifyMessageValue='',
      //连接断开后修改标识
      this.isConnect = false;
    },

    reConnect() {
      console.log("尝试重新连接");
      //如果已经连上就不在重连了
      if (this.isConnect) return;
      this.rec && clearTimeout(this.rec);
      // 延迟5秒重连  避免过多次过频繁请求重连
      this.rec = setTimeout(function() {
        this.initWebSocket();
      }, 5000);
    },

    //打开派单消息弹框提醒 使用的是elementui的Notification 通知
    openInfoNotifySenderOrder(value) {
      const h = this.$createElement;
      this.$notify.info({
        title: "待派订单通知", //标题
        dangerouslyUseHTMLString: true,
        //message: h('i', { style: 'color: teal'}, this.message),
        message: h(
          "a",
          {
            on: {
              click: this.onClickMessageSenderOrder
            }
          },
          value
        ),
        position: "bottom-right" //弹出位置
      });
    },

    onClickMessageSenderOrder() {
      this.$router.push({
        path: "/managers/sendOrder"
      });
    }

    /*webSocket start*/
  }
};
</script>
<style lang="less">
:global {
  .dragable-ghost {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-chose {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-drag {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
}

::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

::-webkit-scrollbar-track {
  border-radius: 1px;
}

::-webkit-scrollbar-thumb {
  border-radius: 1px;
  background: rgba(0, 0, 0, 0.2);
}

.multi-page {
  margin: -24px 0 0;
}

.single-page {
  margin: 0;
}

.card-area {
  width: 100%;
}

.not-menu-page {
  background: #fff;
  padding: 16px 32px;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.ant-btn,
.ant-input,
.input,
.ant-pagination-item,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link,
.ant-tag,
.ant-modal-content,
.ant-select-selection,
.ant-select-dropdown,
.ant-input-group-addon,
.ant-input-number-input,
.ant-input-number,
.ant-pagination-options-quick-jumper input,
.ant-alert {
  border-radius: 2px !important;
}

.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab,
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-radius: 3px 3px 0 0 !important;
}

.ant-card-wider-padding .ant-card-body {
  padding: 5px 10px !important;
}

.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.ant-modal-header {
  border-bottom-color: #fff !important;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) inset !important;
}

.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-item {
  margin-top: 0 !important;
}

.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  background: #393e46 !important;
}

.ant-table-row-expand-icon {
  margin-right: 1rem !important;
}

:root .ant-tabs-tab-prev {
  border: 1px solid #e8e8e8;
  border-radius: 3px 0 0 0;
  background: #fafafa;
}

.ant-card-loading {
  &:after {
    width: 0 !important;
  }
}

.ant-tabs-tab-next.ant-tabs-tab-arrow-show {
  border: 1px solid #e8e8e8;
  border-radius: 0 3px 0 0;
  background: #fafafa;
}

.ant-layout-header,
.system-top-menu {
  height: 59px !important;
  line-height: 59px !important;
}

.ant-form-item {
  margin-bottom: 1rem !important;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 0 solid #ccc !important;
}

.ant-drawer-body {
  padding-bottom: 3rem !important;
}

.page-tabs .ant-tabs-close-x {
  color: #fff !important;
  margin-left: 0.3rem !important;
}

.page-tabs:hover .ant-tabs-close-x {
  color: #f95476 !important;
}

.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

.search {
  margin-bottom: 0.5rem !important;
}

i {
  font-size: 0.97rem;
}

p {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}

@media screen and (min-width: 1400px) {
}

@media screen and (max-width: 1399px) {
  p,
  .ant-pagination,
  .ant-form,
  .ant-dropdown,
  .ant-form-item,
  .ant-select,
  .ant-breadcrumb,
  .ant-form label,
  .ant-btn,
  .ant-table,
  .ant-menu-vertical .ant-menu-item,
  .ant-menu-vertical-left .ant-menu-item,
  .ant-menu-vertical-right .ant-menu-item,
  .ant-menu-inline .ant-menu-item,
  .ant-menu-vertical .ant-menu-submenu-title,
  .ant-menu-vertical-left .ant-menu-submenu-title,
  .ant-menu-vertical-right .ant-menu-submenu-title,
  .ant-menu-inline .ant-menu-submenu-title {
    font-size: 13px !important;
  }

  .ant-card-head {
    font-size: 14px !important;
  }

  .page-tabs .ant-tabs-nav-container {
    font-size: 13px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/FEBS.vue